<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.loadingOrderEdit')" type="confirm" width="25%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="args" :rules="rules" :wrapper-col="wrapperCol" colspan="24">
      <a-form-model-item :label="$t('business.label.loadingOrderNo')" prop="orderNo">
          <div v-for="no in  args['orderNos']">
            <vxe-input :editable="false" :value="no" style="width: 90%"/>
          </div>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.deliver')" prop="deliver">
        <vxe-input v-model="args.deliverer" :editable="false" style="width: 90%" @click="()=>this.$refs.deliverModal.open({'role.name':'配送员'})"/>
        <user-modal ref="deliverModal" @change="(e)=>{this.args.deliverer=e.length===0?null:e[0].name}"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.vehicleNo')" prop="vehicleNo">
        <vxe-input v-model="args.vehicle.no" :editable="false" style="width: 90%" @click="()=>this.$refs.vehicleModal.open()"/>
        <vehicle-modal ref="vehicleModal" @change="(e)=>{this.args.vehicle=e.length===0?{id:null,no:null}:e[0]}"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.vehicleInPlaceStatus')" prop="vehicleInPlaceStatus">
        <vxe-input v-model="args.vehicleInPlaceStatus" style="width: 90%"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.driver')" prop="driver">
        <vxe-input v-model="args.driver" :editable="false" style="width: 90%" @click="()=>this.$refs.driverModal.open({'role.name':'司机'})"/>
        <user-modal ref="driverModal" @change="(e)=>{this.args.driver=e.length===0?null:e[0].name}"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.phone')" prop="driverPhone">
        <vxe-input v-model="args.driverPhone" style="width: 90%"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.dock')" prop="dock">
        <vxe-input v-model="args.dock.no" :editable="false" style="width: 90%" @click="()=>$refs.dockModal.open({locationType:3})"/>
        <location-modal ref="dockModal" @change="(e)=>{args.dock=e.length===0?{id:null,no:null}:e[0]}"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.departureTime')" prop="departureTime">
          <a-date-picker
            v-model="args.departureTime"
            show-today
            style="width: 90%"
            valueFormat="YYYY-MM-DD"/>
        </a-form-model-item>
      <a-form-model-item :label="$t('business.label.notes')" prop="notes">
        <vxe-textarea v-model="args.notes" style="width: 90%"/>
        </a-form-model-item>
      </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import Api from '@/api'
import UserModal from '@/views/modal/UserModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import VehicleModal from '@/views/modal/VehicleModal.vue'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'

export default {
  name: 'LoadingOrderEditModal',
  components: { TextAreaModal, VehicleModal, LocationModal, UserModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      args: {
        ids: [],
        orderNos: [],
        dispatcher: null,
        deliverer: null,
        driver: null,
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null,
        vehicle: {
          id: null,
          no: null
        },
        dock: {
          id: null,
          no: null
        }
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      rules: {},
      order: null,
      record: null
    }
  },
  methods: {
    open(records) {
      console.log(records)
      if (records.length > 0) {
        records.forEach(record => {
          this.args.ids.push(record.order.id)
          this.args.orderNos.push(record.order.no)
        })
      }
      if (records.length === 1) {
        this.args.dispatcher = records[0].order.dispatcher
        this.args.deliverer = records[0].order.deliverer
        this.args.driver = records[0].order.driver
        this.args.driverPhone = records[0].order.driverPhone
        this.args.vehicleInPlaceStatus = records[0].order.vehicleInPlaceStatus
        this.args.departureTime = records[0].order.departureTime
        this.args.notes = records[0].order.notes
        this.args.vehicle = records[0].vehicle === null || records[0].vehicle === undefined ? this.args.vehicle : records[0].vehicle
        this.args.dock = records[0].dock === null || records[0].dock === undefined ? this.args.dock : records[0].dock
      }
      this.visible = true
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          let checkInData = {
            ids: this.args.ids,
            dispatcher: this.args.dispatcher,
            deliverer: this.args.deliverer,
            driver: this.args.driver,
            driverPhone: this.args.driverPhone,
            vehicleInPlaceStatus: this.args.vehicleInPlaceStatus,
            departureTime: this.args.departureTime,
            notes: this.args.notes,
            'vehicle.id': this.args.vehicle.id,
            'dock.id': this.args.dock.id
          }
          post(Api.deliveryCheckIn, {}, checkInData).then(res => {
            if (res.success) {
              this.$message.success('保存成功')
              this.$emit('postSave')
              this.onClose()
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    onClose() {
      this.visible = false
      this.clear()
    },
    clear() {
      this.args = {
        ids: [],
        orderNos: [],
        dispatcher: null,
        deliverer: null,
        driver: null,
        vehicle: {
          id: null,
          no: null
        },
        dock: {
          id: null,
          no: null
        },
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null
      }
    }
  }
}
</script>